var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmpty3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 637,
    height: 448,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty_3_svg__clip0_10367_210187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M524.451 164.503H389.292a2.974 2.974 0 00-2.972 2.976v1.142a2.974 2.974 0 002.972 2.976h135.159a2.974 2.974 0 002.972-2.976v-1.142a2.974 2.974 0 00-2.972-2.976z",
    fill: "#F2F2F2",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.058 131.896h-4.38a2.975 2.975 0 00-2.972 2.976v4.386a2.975 2.975 0 002.972 2.976h4.38a2.974 2.974 0 002.972-2.976v-4.386a2.974 2.974 0 00-2.972-2.976z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.706 135.271V56.298M462.036 135.271V56.376M524.053 164.509l-63.704-22.275h-6.954l-63.705 22.275M432.241 34.267L552.844.536a2.97 2.97 0 013.043.434l63.003 33.327",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.257 3.166l-8.458 56.453h4.618l6.758-46.11 5.48 46.11h4.404l-6.912-56.346c-.422-3.463-5.379-3.529-5.89-.107z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.655 38.326l13.546 13.562 13.498-13.515 13.593 13.61 13.564-13.58 13.593 13.605 13.741-13.76 13.944 13.962",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.825 34.267h-84.584l-16.933 16.955a2.971 2.971 0 00-.642 3.239 2.972 2.972 0 002.74 1.838l117.339.077V52.21l-17.92-17.943zM419.896 52.21l13.76-13.777h81.755L529.17 52.21H419.896z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.463 38.326l-13.546 13.563-13.498-13.516-13.593 13.61",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.836 51.3l-16.952-17.033h-29.896l-17.92 17.943h-2.972v4.166h65.635a2.967 2.967 0 002.745-1.835 2.98 2.98 0 00-.64-3.242zm-59.193.91l13.759-13.777h27.068l13.759 13.777h-54.586zM571.067 77.312h-4.161v240.976h4.161V77.312zM543.316 77.312h-4.161v240.976h4.161V77.312z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.906 77.312l-23.53 23.561 23.584 23.614-23.638 23.668 23.608 23.644-23.554 23.585 23.554 23.584-23.584 23.609 23.614 23.644-23.691 23.721",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.067 78.324h-36.364a2.966 2.966 0 01-2.538-1.435l-3.536-5.844a2.971 2.971 0 01-.315-2.38l4.101-14.343a2.972 2.972 0 012.853-2.154h35.799v26.156z",
    fill: "#88F4CB",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.474 52.186h-22.206a2.972 2.972 0 00-2.853 2.154l-3.376 11.796a2.979 2.979 0 002.859 3.797h22.586a2.975 2.975 0 002.972-2.976l.018-14.771z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.423 59.625l10.912-11.081-8.113-8.278 6.36-6.517-4.672-4.826 3.602-3.6",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.361 151.928L184.563 16.556l356.435 356.887H25.45l23.912-221.515z",
    fill: "#DDF8EF",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.554 188.445H141.769v147.524h125.785V188.445z",
    fill: "#fff",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.95 160.635L189.703 21.704 405.007 237.28l-13.967 13.985L197.217 57.197 90.552 163.99l-39.603-3.356z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.865 159.236L180.86 17.056a2.971 2.971 0 014.202 0l213.206 213.475-13.968 13.986L190.476 50.448 83.811 157.242l-44.946 1.994z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.476 90.458a13.313 13.313 0 019.423 3.908 13.356 13.356 0 013.903 9.435v31.101H177.15v-31.101c0-3.539 1.404-6.933 3.903-9.435a13.318 13.318 0 019.423-3.908z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.991 90.702a13.304 13.304 0 00-11.953 3.655 13.346 13.346 0 00-3.911 9.443v31.102h5.034v-31.101a13.352 13.352 0 013.061-8.5 13.324 13.324 0 017.769-4.599z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.525 188.445v141.251M169.525 274.255h98.029",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.912 227.431a11.61 11.61 0 003.566-9.82 3.306 3.306 0 01.939-2.725 3.298 3.298 0 014.66 0l42.408 42.462a2.973 2.973 0 004.202 0l91.574-91.69a11.91 11.91 0 000-16.83l-91.603-91.69a2.973 2.973 0 00-4.203 0l-42.408 42.461a3.303 3.303 0 001.254 5.449c.471.162.973.216 1.469.157a11.576 11.576 0 019.807 3.571c3.964 4.166 4.071 11.51.22 15.8a11.624 11.624 0 01-18.805-2.069 11.657 11.657 0 01-1.404-7.113 3.252 3.252 0 00-.945-2.684 3.279 3.279 0 00-3.592-.718 3.3 3.3 0 00-1.068.718l-42.402 42.456a2.964 2.964 0 00-.873 2.106 2.978 2.978 0 00.873 2.107l42.402 42.456a3.29 3.29 0 010 4.666 3.26 3.26 0 01-1.231.782c-.465.163-.96.22-1.449.164a11.612 11.612 0 00-7.108 1.401 11.641 11.641 0 00-5.687 12.555 11.648 11.648 0 003.629 6.278c4.28 3.826 11.597 3.719 15.775-.25z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.144 141.924l-29.915-29.958-5.735 5.743-4.91-4.916-49.053 49.115 4.91 4.916-5.73 5.737 29.914 29.958 5.73-5.743 4.91 4.916 49.053-49.115-4.91-4.916 5.736-5.737z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.959 114.304l-6.796 6.805 3.371 3.375 6.796-6.805-3.371-3.375z",
    fill: "#FCBF4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.959 114.304l-6.796 6.805 3.371 3.375 6.796-6.805-3.371-3.375z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.719 130.573l-6.796 6.805 3.371 3.375 6.795-6.805-3.37-3.375z",
    fill: "#FCBF4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.719 130.573l-6.796 6.805 3.371 3.375 6.795-6.805-3.37-3.375z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.475 146.838l-6.796 6.805 3.37 3.375 6.796-6.805-3.37-3.375z",
    fill: "#FCBF4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.475 146.838l-6.796 6.805 3.37 3.375 6.796-6.805-3.37-3.375z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.065 157.467l-6.795 6.804 3.37 3.375 6.796-6.804-3.371-3.375z",
    fill: "#FCBF4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.065 157.467l-6.795 6.804 3.37 3.375 6.796-6.804-3.371-3.375z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.821 173.731l-6.796 6.805 3.371 3.375 6.796-6.805-3.371-3.375z",
    fill: "#FCBF4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.821 173.731l-6.796 6.805 3.371 3.375 6.796-6.805-3.371-3.375z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.577 189.996l-6.796 6.805 3.371 3.375 6.796-6.805-3.371-3.375z",
    fill: "#FCBF4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.577 189.996l-6.796 6.805 3.371 3.375 6.796-6.805-3.371-3.375z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.216 112.794l-49.051 49.113 39.733 39.784 49.051-49.114-39.733-39.783z",
    fill: "#88F4CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.216 112.794l-49.051 49.113 39.733 39.784 49.051-49.114-39.733-39.783z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.862 111.965l-60.52 60.597 29.915 29.953 60.521-60.597-29.916-29.953z",
    fill: "#88F4CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.862 111.965l-60.52 60.597 29.915 29.953 60.521-60.597-29.916-29.953zM260.564 117.709a5.361 5.361 0 010-7.552l31.02-31.066M244.29 133.973l-2.377-2.38a5.362 5.362 0 010-7.552l7.227-7.237a5.356 5.356 0 000-7.552l-17.884-17.901M228.243 150.399l-10.301-10.314a5.347 5.347 0 00-7.542 0l-31.026 31.059M274.55 196.776l.041.036a5.362 5.362 0 010 7.558l-31.026 31.059M290.794 180.512l8.838 8.849a5.362 5.362 0 010 7.552l-13.177 13.194a5.36 5.36 0 000 7.552l11.329 11.349M307.038 164.247l6.265 6.255a5.347 5.347 0 007.542 0l13.605-13.623a5.356 5.356 0 000-7.552l-10.77-10.783a5.361 5.361 0 010-7.552l9.873-9.885M190.477 22.478V50.46h-42.313V92.81h-42.955v43.039h-43.05v20.305",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.423 383.37a11.56 11.56 0 009.433-4.434 3.297 3.297 0 014.92-.296c.617.619.964 1.457.964 2.332v60.047a2.974 2.974 0 002.972 2.976h129.501a11.88 11.88 0 008.405-3.486 11.908 11.908 0 003.482-8.416V302.428a2.973 2.973 0 00-2.972-2.976h-59.942a3.295 3.295 0 00-2.038 5.886 11.63 11.63 0 014.434 9.45c-.155 5.767-5.255 11.022-11.002 11.308a11.623 11.623 0 01-11.532-7.525 11.647 11.647 0 013.722-13.269 3.274 3.274 0 001.23-2.571 3.293 3.293 0 00-3.293-3.297H155.73a2.975 2.975 0 00-2.972 2.976v60.048a3.293 3.293 0 01-5.86 2.065 11.627 11.627 0 00-6.016-4.038 11.604 11.604 0 00-7.236.311 11.646 11.646 0 00-7.515 11.547c.285 5.772 5.533 10.878 11.292 11.027z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.852 339.194H188.55c-4.924 0-8.915 3.997-8.915 8.927v17.324c0 4.93 3.991 8.927 8.915 8.927h17.302c4.924 0 8.916-3.997 8.916-8.927v-17.324c0-4.93-3.992-8.927-8.916-8.927z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.831 346.639l-11.216 20.282-12.042-12.057",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.248 339.194h-17.302c-4.924 0-8.916 3.997-8.916 8.927v17.324c0 4.93 3.992 8.927 8.916 8.927h17.302c4.924 0 8.915-3.997 8.915-8.927v-17.324c0-4.93-3.991-8.927-8.915-8.927z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.225 346.639l-11.209 20.282-12.048-12.057",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.881 284.11a11.626 11.626 0 004.434 9.451 3.317 3.317 0 011.26 2.588 3.3 3.3 0 01-2.035 3.053c-.4.166-.83.251-1.264.25H11.3a2.97 2.97 0 00-2.972 2.976v129.665a11.91 11.91 0 003.482 8.416 11.88 11.88 0 008.406 3.486h129.512a2.974 2.974 0 002.972-2.976v-60.047a3.3 3.3 0 00-.965-2.332 3.29 3.29 0 00-4.92.296 11.565 11.565 0 01-9.432 4.434c-5.76-.149-11.008-5.255-11.293-11.01a11.652 11.652 0 011.884-6.97 11.615 11.615 0 0118.841-.849 3.255 3.255 0 002.568 1.231 3.279 3.279 0 002.328-.965 3.287 3.287 0 00.965-2.332v-60.047a2.975 2.975 0 00-2.972-2.976H89.755a3.29 3.29 0 01-3.292-3.303 3.27 3.27 0 011.23-2.565 11.654 11.654 0 00-.812-18.923 11.608 11.608 0 00-6.998-1.87c-5.754.303-10.847 5.558-11.002 11.319z",
    fill: "#88F4CB",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.542 322.852h-17.831a5.948 5.948 0 00-5.943 5.951v17.854a5.947 5.947 0 005.943 5.951h17.831a5.947 5.947 0 005.944-5.951v-17.854a5.948 5.948 0 00-5.944-5.951z",
    fill: "#F34C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.542 322.852h-17.831a5.948 5.948 0 00-5.943 5.951v17.854a5.947 5.947 0 005.943 5.951h17.831a5.947 5.947 0 005.944-5.951v-17.854a5.948 5.948 0 00-5.944-5.951z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.314 322.852H31.632a2.38 2.38 0 00-2.377 2.381 2.379 2.379 0 002.377 2.38h54.682a2.379 2.379 0 002.378-2.38 2.38 2.38 0 00-2.378-2.381z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.314 322.852H31.632a2.38 2.38 0 00-2.377 2.381 2.379 2.379 0 002.377 2.38h54.682a2.379 2.379 0 002.378-2.38 2.38 2.38 0 00-2.378-2.381z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.61 334.457H31.93a2.38 2.38 0 00-2.378 2.381 2.379 2.379 0 002.377 2.38h54.682a2.38 2.38 0 002.377-2.38 2.38 2.38 0 00-2.377-2.381z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.61 334.457H31.93a2.38 2.38 0 00-2.378 2.381 2.379 2.379 0 002.377 2.38h54.682a2.38 2.38 0 002.377-2.38 2.38 2.38 0 00-2.377-2.381z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.014 373.735H31.929a2.38 2.38 0 00-2.377 2.381 2.379 2.379 0 002.377 2.38h80.085a2.38 2.38 0 000-4.761z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.014 373.735H31.929a2.38 2.38 0 00-2.377 2.381 2.379 2.379 0 002.377 2.38h80.085a2.38 2.38 0 000-4.761z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.392 384.447h-84.84v4.761h84.84v-4.761z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.392 384.447h-84.84v4.761h84.84v-4.761z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.117 264.037s27.478-45.581 97.732-45.581c61.38 0 107.657 46.325 107.657 46.325L491.202 317.8l8.916 8.927s-8.916 20.656-8.916 43.741H373.779c0-43.337-14.859-56.328-14.859-56.328l-24.803-50.103z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.083 203.049s2.377 18.056-5.706 25.983c8.464 2.975 7.548 9.266 24.107 9.266 16.559 0 27.936-6.422 25.695-8.683-5.082-5.088-13.772-22.258-14.919-26.566-1.147-4.309-29.177 0-29.177 0z",
    fill: "#FFCBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.083 203.049s2.377 18.056-5.706 25.983c8.464 2.975 7.548 9.266 24.107 9.266 16.559 0 27.936-6.422 25.695-8.683-5.082-5.088-13.772-22.258-14.919-26.566-1.147-4.309-29.177 0-29.177 0z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.341 178.726c1.189 2.684 1.623 6.582 2.021 10.879.238 2.636-1.783 10.206-1.581 11.212.16.792 3.316.744 3.524 1.506.827 3.077.63 5.606 1.57 8.421 3.096 9.284 37.831 6.463 40.559-4.482 1.623-6.474 5.611-24.399-1.932-29.928-7.542-5.529-46.747-3.351-44.161 2.392z",
    fill: "#FFCBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.341 178.726c1.189 2.684 1.623 6.582 2.021 10.879.238 2.636-1.783 10.206-1.581 11.212.16.792 3.316.744 3.524 1.506.827 3.077.63 5.606 1.57 8.421 3.096 9.284 37.831 6.463 40.559-4.482 1.623-6.474 5.611-24.399-1.932-29.928-7.542-5.529-46.747-3.351-44.161 2.392z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.267 170.99c0 7.891 5.224 13.58 7.483 13.188a16.555 16.555 0 00-.743-3.571c2.306-3.981 18.877-6.296 25.813-1.66 2.514 1.672 1.854 5.076 7.245 2.38 9.261-4.612 13.421 8.022 9.7 13.599-1.711 2.564-1.188 11.015 2.847 14.473 7.501 6.451 17.944 7.338 23.098 7.338-7.359-9.838-.631-68.838-41.481-68.838-23.555.018-33.962 13.021-33.962 23.091z",
    fill: "#F34C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.267 170.99c0 7.891 5.224 13.58 7.483 13.188a16.555 16.555 0 00-.743-3.571c2.306-3.981 18.877-6.296 25.813-1.66 2.514 1.672 1.854 5.076 7.245 2.38 9.261-4.612 13.421 8.022 9.7 13.599-1.711 2.564-1.188 11.015 2.847 14.473 7.501 6.451 17.944 7.338 23.098 7.338-7.359-9.838-.631-68.838-41.481-68.838-23.555.018-33.962 13.021-33.962 23.091z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.161 268.435c21.178 21.204 38.165 64.915 38.165 102.045h-70.165c0-9.1-12.078-44.688-19.935-52.68 15.18-15.241 45.611-43.033 51.935-49.365zM286.122 240.684s24.113 137.949 103.705 58.251c-36.286-36.338-68.875-67.106-73.559-80.937-1.872-5.54-3.899-12.462-5.064-16.931-4.796-18.449-25.207-7.463-19.328 10.784 1.271 3.951 3.726 12.098 5.943 17.193l4.238 4.243-4.238-4.243-11.697 11.64z",
    fill: "#FFCBBD",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.742 248.442l-4.203 4.208 46.26 46.319 4.203-4.208-46.26-46.319z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.313 285.437l-13.486 13.498M491.202 317.8l-15.477-15.497",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.433 268.708l-4.203-4.208-50.736 50.801 4.203 4.208 50.736-50.801z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.842 369.176H279.84v8.927h303.002v-8.927z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.016 215.529a11.563 11.563 0 00-9.433 4.439 3.31 3.31 0 01-2.592 1.262 3.3 3.3 0 01-3.292-3.303v-60.042a2.975 2.975 0 00-2.972-2.975H20.215a11.88 11.88 0 00-8.406 3.486 11.909 11.909 0 00-3.482 8.416v129.665a2.97 2.97 0 002.972 2.975h59.977a3.28 3.28 0 002.335-.965 3.303 3.303 0 00.964-2.338 3.316 3.316 0 00-1.26-2.588 11.62 11.62 0 01-4.434-9.451c.155-5.761 5.254-11.016 11.002-11.307a11.608 11.608 0 016.998 1.87 11.633 11.633 0 014.534 5.655 11.654 11.654 0 01-3.722 13.268 3.266 3.266 0 00-1.23 2.565 3.3 3.3 0 002.03 3.052c.4.166.83.251 1.262.251h59.972a2.975 2.975 0 002.972-2.975v-60.048a3.3 3.3 0 01.964-2.331 3.289 3.289 0 012.328-.966 3.257 3.257 0 012.568 1.232 11.623 11.623 0 0013.252 3.727 11.639 11.639 0 007.515-11.547c-.303-5.773-5.551-10.873-11.31-11.027z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.193 221.521c-1.082-1.696-3.531-3.749-6.194-5.165a15.481 15.481 0 004.948-17.208 15.468 15.468 0 00-5.643-7.507 15.436 15.436 0 00-17.884 0 15.472 15.472 0 00-5.644 7.507 15.495 15.495 0 00-.264 9.394 15.478 15.478 0 005.212 7.814c-2.663 1.416-5.117 3.469-6.193 5.165-1.843 2.899-8.024 13.254-8.024 33.922h47.71c0-20.668-6.188-31.023-8.024-33.922z",
    fill: "#001E3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.193 221.521c-1.082-1.696-3.531-3.749-6.194-5.165a15.481 15.481 0 004.948-17.208 15.468 15.468 0 00-5.643-7.507 15.436 15.436 0 00-17.884 0 15.472 15.472 0 00-5.644 7.507 15.495 15.495 0 00-.264 9.394 15.478 15.478 0 005.212 7.814c-2.663 1.416-5.117 3.469-6.193 5.165-1.843 2.899-8.024 13.254-8.024 33.922h47.71c0-20.668-6.188-31.023-8.024-33.922z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.048 221.521c-1.076-1.696-3.53-3.749-6.193-5.165a15.478 15.478 0 005.212-7.814 15.495 15.495 0 00-.264-9.394 15.472 15.472 0 00-5.644-7.507 15.435 15.435 0 00-17.884 0 15.472 15.472 0 00-5.644 7.507 15.495 15.495 0 00-.264 9.394 15.478 15.478 0 005.213 7.814c-2.663 1.416-5.112 3.469-6.194 5.165-1.836 2.899-8.024 13.254-8.024 33.922h47.71c0-20.668-6.181-31.023-8.024-33.922z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.048 221.521c-1.076-1.696-3.53-3.749-6.193-5.165a15.478 15.478 0 005.212-7.814 15.495 15.495 0 00-.264-9.394 15.472 15.472 0 00-5.644-7.507 15.435 15.435 0 00-17.884 0 15.472 15.472 0 00-5.644 7.507 15.479 15.479 0 004.948 17.208c-2.662 1.416-5.111 3.469-6.193 5.165-1.836 2.899-8.024 13.254-8.024 33.922h47.71c0-20.668-6.181-31.023-8.024-33.922z",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.363 350.359c-16.642 2.755-30.705 7.778-43.264 15.675-5.533 2.303-16.095 12.343-16.095 12.343h17.724c.321 24.691-.042 69.629-.042 69.629H.237l.458-85.816s28.678 29.69 87.58 9.069c30.645-10.712 46.289-15.39 64.863-15.39 23.18 0 44.12 16.414 77.808 16.414 33.689 0 34.147-29.161 81.946-29.161 9.058 0 18.217 2.767 27.471 7.255",
    fill: "#F3F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.363 350.359c39.585 19.175 80.995 69.778 124.318 69.778 66.153 0 144.151-42.04 144.151-42.04l-85.588-2.172c-87.836 37.308-103.794-28.256-145.679-28.256-13.742 0-26.034.839-37.178 2.69",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.363 350.359c39.585 19.175 80.995 69.778 124.318 69.778 66.153 0 144.151-42.04 144.151-42.04l-85.588-2.172c-87.836 37.308-103.794-28.256-145.679-28.256-13.742 0-26.034.839-37.178 2.69",
    stroke: "#001E3C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.176 402.819c35.781 6.153 43.424-29.631 62.373-30.542 18.948-.911 37.356 18.943 46.746 9.391 9.391-9.552-11.239-27.167 2.455-32.107 13.694-4.939 22.206 13.39 30.188 9.451 7.982-3.94 5.082-16.931 13.504-14.64 8.422 2.291 13.7 4.094 19.876 7.683 10.389 6.046 9.236-4.386 26.996-4.386 17.759 0 5.997 26.387 14.086 32.529 8.09 6.142 35.109-11.682 47.484-4.922 12.375 6.761-2.062 39.082 20.702 43.682 22.764 4.6 32.232-31.172 53.113-36.743 20.88-5.57 48.738 20.538 67.002 13.093 18.265-7.445 14.497-21.674 22.087-23.751",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.633 375.925c-87.835 37.308-102.611-28.256-144.49-28.256-48.738 0-79.217 10.474-105.167 39.653-25.95 29.178-103.8 15.473-103.8 15.473",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.987 412.995a4.555 4.555 0 004.553-4.558 4.556 4.556 0 00-4.553-4.559 4.555 4.555 0 00-4.552 4.559 4.555 4.555 0 004.552 4.558z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.712 394.16a4.556 4.556 0 004.553-4.559 4.556 4.556 0 00-4.553-4.559 4.556 4.556 0 00-4.553 4.559 4.556 4.556 0 004.553 4.559z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.296 387.613a4.556 4.556 0 004.553-4.558 4.556 4.556 0 00-4.553-4.559 4.556 4.556 0 00-4.553 4.559 4.556 4.556 0 004.553 4.558z",
    fill: "#88F4CB",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.827 376.705a4.556 4.556 0 004.553-4.559 4.555 4.555 0 00-4.553-4.558 4.556 4.556 0 00-4.553 4.558 4.556 4.556 0 004.553 4.559zM571.067 392.172a4.556 4.556 0 004.553-4.559 4.555 4.555 0 00-4.553-4.558 4.555 4.555 0 00-4.552 4.558 4.555 4.555 0 004.552 4.559z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.213 359.083a4.556 4.556 0 004.553-4.558 4.556 4.556 0 00-4.553-4.559 4.556 4.556 0 00-4.553 4.559 4.556 4.556 0 004.553 4.558z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.038 354.525a4.556 4.556 0 004.553-4.559 4.556 4.556 0 00-4.553-4.559 4.556 4.556 0 00-4.553 4.559 4.556 4.556 0 004.553 4.559z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.411 360.767a4.555 4.555 0 004.553-4.558 4.556 4.556 0 00-4.553-4.559 4.556 4.556 0 00-4.553 4.559 4.556 4.556 0 004.553 4.558z",
    fill: "#88F4CB",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.924 380.674a4.556 4.556 0 004.553-4.559 4.556 4.556 0 00-4.553-4.558 4.555 4.555 0 00-4.553 4.558 4.556 4.556 0 004.553 4.559z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.476 385.233a4.556 4.556 0 004.553-4.559 4.556 4.556 0 00-4.553-4.559 4.556 4.556 0 00-4.553 4.559 4.556 4.556 0 004.553 4.559z",
    fill: "#6EC6DA",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.598 398.718a4.556 4.556 0 004.553-4.558 4.556 4.556 0 00-4.553-4.559 4.556 4.556 0 00-4.553 4.559 4.555 4.555 0 004.553 4.558z",
    fill: "#F34C54",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.297 362.184s28.678 29.69 87.58 9.069c30.645-10.712 46.289-15.389 64.863-15.389 23.18 0 44.12 16.413 77.808 16.413 33.689 0 34.141-29.161 81.946-29.161s98.338 77.032 151.789 77.032c68.738 0 144.55-42.039 144.55-42.039",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.239 369.176H496.468a2.975 2.975 0 00-2.972 2.976v2.976a2.974 2.974 0 002.972 2.975h111.771a2.973 2.973 0 002.971-2.975v-2.976a2.974 2.974 0 00-2.971-2.976z",
    fill: "#001E3C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.985 313.015c10.843 0 19.632-8.801 19.632-19.657s-8.789-19.657-19.632-19.657c-10.842 0-19.631 8.801-19.631 19.657s8.789 19.657 19.631 19.657z",
    fill: "#fff",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.038 267.506l-16.559 20.282h-11.138l-11.786 34.041 14.704-24.942h10.568l14.211-29.381z",
    fill: "#FCBF4C",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.778 188.95h5.783-5.783z",
    fill: "#FFCBBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.778 188.95h5.783",
    stroke: "#001E3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty_3_svg__clip0_10367_210187"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h637v448H0z"
  })))));
}

export default SvgEmpty3;